import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../../../../core/img/imagewithbasebath";
import { BASE_CRM_URL } from "../../../../components/config/config";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
const ViewProposal = () => {
  const { id } = useParams();

  console.log(id, "idddddddddddddddddd"); // e.g. 2

  const getProposalStatus = (status) => {
    switch (status) {
      case 1:
        return "Draft";
      case 2:
        return "Sent";
      case 3:
        return "Open";
      case 4:
        return "Revised";
      case 5:
        return "Declined";
      case 6:
        return "Accepted";
      default:
        return "Unknown";
    }
  };

  const [proposalDetails, setProposalDetails] = useState(null);

  console.log(proposalDetails, "proposaldetailsssssssssssssssss");

  const getProposal = async (id) => {
    try {
      const response = await fetch(`${BASE_CRM_URL}proposal/GetProposal/${id}`);

      const data = await response.json();

      setProposalDetails(data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getProposal(id);
  }, []);
  return (
    <div className="page-wrapper">
      <div className="content">
        <nav aria-label="breadcrumb">
          <div className="d-flex justify-content-between align-items-center">
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <Link to="/crm/Dashboard">
                  <i className="fas fa-home fa-lg" />
                </Link>
              </li>
              <h4 className="breadcrumb-item mb-2" aria-current="page">
                View Proposals
              </h4>
            </ol>
          </div>
        </nav>

        <div className="d-flex align-items-center mb-2">
          <div>
            <h5 className="mb-0"># PRO-{proposalDetails?.Proposal?.id}</h5>
            <p>{proposalDetails?.Proposal?.subject}</p>
          </div>
          <div className="ms-auto d-flex align-items-center">
            <Link className="btn btn-white border-1 me-2">
              <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
            </Link>
            {/* <Link className="btn btn-danger me-2">
              <i className="fas fa-x me-2"></i>Decline
            </Link>

            <Link className="btn btn-success me-2">
              <i className="fa-solid fa-check me-2 text-white"></i>Accept
            </Link> */}

            <Link to="/crm/proposals" className="btn btn-secondary ">
              <i className="fa-solid fa-arrow-left me-2"></i>Back
            </Link>
          </div>
        </div>
        {/* Main Layout (Table on the left, Content on the right) */}
        <div className="row">
          {/* Table on the left */}
          <div className="col-8">
            <div className="card p-3 mb-3">
              {/* 
              <table className="table-responsive">
                <thead className="bg-soft-info">
                  <tr>
                    <th>#</th>
                    <th>Item</th>
                    <th>Qty</th>
                    <th>Rate</th>
                    <th>Tax</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {proposalDetails?.ItemDetails?.map((item, index) => {
                    const amount = Number(item.qty) * Number(item.rate);

                    return (
                      <tr key={item.id}>
                        <td>{index + 1}</td>
                        <td>
                          <b>{item.description}</b>
                        
                        </td>
                        <td>
                          {item.qty} {item.unit}
                        </td>
                        <td>Rs. {Number(item.rate).toLocaleString()}</td>
                        <td>
                          Rs.{" "}
                          {(
                            Number(proposalDetails?.Proposal.total_tax) /
                            proposalDetails?.ItemDetails.length
                          ).toFixed(2)}
                        </td>
                        <td>Rs. {amount.toLocaleString()}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table> */}

              <div className="table-responsive">
                <table className="table table-bordered table-hover align-middle mb-0">
                  <thead className="table-primary">
                    <tr>
                      <th style={{ width: 60 }}>#</th>
                      <th>Item</th>
                      <th className="text-center">Qty</th>
                      <th className="text-end">Rate</th>
                      <th className="text-end">Tax</th>
                      <th className="text-end">Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {proposalDetails?.ItemDetails?.map((item, index) => {
                      const amount = Number(item.qty) * Number(item.rate);

                      return (
                        <tr key={item.id}>
                          <td className="fw-semibold">{index + 1}</td>

                          <td
                            style={{
                              maxWidth: "300px",
                              whiteSpace: "normal",
                              wordBreak: "break-word",
                            }}
                          >
                            <div className="fw-semibold text-dark">
                              {item.description}
                            </div>
                          </td>

                          <td className="text-center">
                            <span className="badge bg-light text-dark border">
                              {item.qty}
                            </span>
                          </td>

                          <td className="text-end">
                            ₹ {Number(item.rate).toLocaleString()}
                          </td>

                          <td className="text-end">
                            ₹{" "}
                            {(
                              Number(proposalDetails?.Proposal.total_tax) /
                              proposalDetails?.ItemDetails.length
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </td>

                          <td className="text-end fw-bold text-success">
                            ₹ {amount.toLocaleString()}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              <hr />
              <div className="d-flex justify-content-end">
                <table className="table w-auto">
                  <tbody>
                    <tr>
                      <td>Sub Total</td>
                      <td>
                        Rs.{" "}
                        {Number(
                          proposalDetails?.Proposal.subtotal
                        ).toLocaleString()}
                      </td>
                    </tr>

                    <tr>
                      <td>Total Tax</td>
                      <td>
                        Rs.{" "}
                        {Number(
                          proposalDetails?.Proposal.total_tax
                        ).toLocaleString()}
                      </td>
                    </tr>

                    <tr>
                      <td>Adjustment</td>
                      <td>
                        Rs.{" "}
                        {Number(
                          proposalDetails?.Proposal.adjustment
                        ).toLocaleString()}
                      </td>
                    </tr>

                    <tr>
                      <th>Total</th>
                      <th>
                        Rs.{" "}
                        {Number(
                          proposalDetails?.Proposal.total
                        ).toLocaleString()}
                      </th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Right side content */}
          <div className="col-4 card">
            <div className="card-body">
              <ul className="nav nav-tabs nav-tabs-bottom mb-3">
                <li className="nav-item">
                  <Link
                    className="nav-link active"
                    to="#bottom-tab1"
                    data-bs-toggle="tab"
                  >
                    <i className="fas fa-file me-2"></i>
                    Summary
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="#bottom-tab2"
                    data-bs-toggle="tab"
                  >
                    <i className="fas fa-comment me-2"></i>
                    Discussion
                  </Link>
                </li>
              </ul>
              <div className="tab-content">
                <div className="tab-pane show active" id="bottom-tab1">
                  <div className="row">
                    <div className="col-12">
                      {/* Company Info */}
                      <div className="mt-3 p-3 border rounded bg-light">
                        <h6 className="text-primary fw-bold mb-3">
                          <i className="fa-solid fa-building me-2"></i>
                          Perennial Code IT Consultants Pvt. Ltd.
                        </h6>

                        <p className="mb-1">
                          <i className="fa-solid fa-location-dot text-danger me-2"></i>
                          Vidya Nagar
                        </p>

                        <p className="mb-1">
                          <i className="fa-solid fa-map-location-dot text-success me-2"></i>
                          Hyderabad, Telangana
                        </p>

                        <p className="mb-1">
                          <i className="fa-solid fa-earth-asia text-info me-2"></i>
                          INDIA - 500044
                        </p>

                        <p className="mb-1">
                          <i className="fa-solid fa-file-invoice text-warning me-2"></i>
                          GSTIN: 36AAHCP3604R1ZM
                        </p>

                        <p className="mb-0">
                          <i className="fa-solid fa-phone-volume text-primary me-2"></i>
                          +91 4048513363, +91 8297230010
                        </p>
                      </div>

                      {/* Proposal Information */}
                      <div className="mt-4 p-3 border rounded bg-light">
                        <h6 className="text-success fw-bold mb-3">
                          <i className="fa-solid fa-user me-2"></i>
                          Proposal Information
                        </h6>

                        <p className="mb-2 fw-semibold ">
                          <i className="fa-solid fa-user-tie text-primary me-2"></i>
                          {proposalDetails?.Proposal.proposal_to}
                        </p>

                        <p className="mb-2">
                          <i className="fa-solid fa-location-dot text-danger me-2"></i>
                          {proposalDetails?.Proposal.address}
                        </p>

                        <p className="mb-2">
                          <i className="fa-solid fa-city text-secondary me-2"></i>
                          {proposalDetails?.Proposal.city},{" "}
                          {proposalDetails?.Proposal.state} -{" "}
                          {proposalDetails?.Proposal.zip}
                        </p>

                        <p className="mb-2">
                          <i className="fa-solid fa-phone text-success me-2"></i>
                          {proposalDetails?.Proposal.phone}
                        </p>

                        <p className="mb-0">
                          <i className="fa-solid fa-envelope text-info me-2"></i>
                          {proposalDetails?.Proposal.email}
                        </p>
                      </div>

                      {/* Summary Card */}
                      <div className="card border-0 shadow-sm mt-4">
                        <div className="card-body">
                          <h4 className="text-primary fw-bold mb-3">
                            <i className="fa-solid fa-indian-rupee-sign me-2"></i>
                            {Number(
                              proposalDetails?.Proposal.total
                            ).toLocaleString()}
                          </h4>

                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <span>
                              <i className="fa-solid fa-circle-check text-success me-2"></i>
                              Status
                            </span>

                            <span className="badge bg-soft-info px-3 py-2">
                              {getProposalStatus(
                                proposalDetails?.Proposal.status
                              )}
                            </span>
                          </div>

                          <hr />

                          <p className="mb-2">
                            <i className="fa-regular fa-calendar text-primary me-2"></i>
                            <strong>Date:</strong>{" "}
                            {dayjs(proposalDetails?.Proposal.datecreated).format("DD-MM-YYYY")}
                          </p>

                          <p className="mb-2">
                            <i className="fa-regular fa-clock text-warning me-2"></i>
                            <strong>Open Till:</strong>{" "}
                          
                            {dayjs(proposalDetails?.Proposal.open_till).format("DD-MM-YYYY")}
                          </p>

                          <p className="mb-0">
                            <i className="fa-solid fa-user-check text-info me-2"></i>
                            <strong>Assigned:</strong>{" "}
                            {proposalDetails?.Proposal.AddedByName}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tab-pane" id="bottom-tab2">
                  <div className="mt-4">
                    <textarea
                      className="form-control"
                      rows="4"
                      placeholder="Enter your discussion here..."
                    ></textarea>
                    <button className="btn btn-primary mt-3">
                      Add Comment
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewProposal;
